import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import useSWR from "swr";
import type { Bar } from "./models/bar";
import { formatNumber } from "./utils/number-format";

const App: FC<{ bar: Bar | null }> = ({ bar }) => {
	if (!bar) return <></>;

	const StyledBar = styled.div`
    display: block;
    color: hsl(
      ${bar.textColorHue},
      ${bar.textColorSaturation * 100}%,
      ${bar.textColorBrightness * 100}%
    );
    height: 44px;
    & > div {
      opacity: 1;
      background-color: hsl(
        ${bar.bgColorHue},
        ${bar.bgColorSaturation * 100}%,
        ${bar.bgColorBrightness * 100}%
      );
      margin: 0;
      padding: 5px;
      left: 0;
      height: auto;
      width: 100%;
      z-index: 9999;
      position: fixed;
      text-align: center;
      vertical-align: middle;
      top: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  `;

	const { data } = useSWR("/cart.js", (url) =>
		fetch(url).then((_) => _.json()),
	);

	if (!data) {
		return <></>;
	}

	let message: string;
	const remainPrice = bar.price - data.total_price / 100;

	if (data.total_price === 0) {
		message = bar.initialMessage;
	} else if (remainPrice > 0 && remainPrice < bar.price) {
		message = bar.progressMessage;
	} else {
		message = bar.completeMessage;
	}
	console.log(`price: ${formatNumber(bar.price)}円`);
	console.log(`remain_price: ${formatNumber(remainPrice)}円`);

	message = message.replace("{price}", `${formatNumber(bar.price)}円`);
	message = message.replace("{remain_price}", `${formatNumber(remainPrice)}円`);

	// TODO: more cleaner
	document.body.style.marginTop = "44px";

	return (
		<StyledBar>
			<div>{message}</div>
		</StyledBar>
	);
};

export default App;
